export default __webpack_public_path__ + "static/media/SWT1420.34I-35379_-20486_0.4f59233a.jpg";